import {
    // pageBuilder,
    account,
    // commissions,
    conversions,
    coupons,
    dashboard,
    developers,
    products,
    transactions,
    links,
    media,
    promotions,
    publishers,
    reports,
    stores,
    users,
    notifications,
    tickets,
    setup,
    // roles,
    v2commissions,
    oauth2,
    shortLinks,
    agreements,
    contactUs,
    campaigns,
    tags,
    conversations,
} from './routes/index'

const TheContainer = () => import ('@/containers/TheContainer')
const EmptyNonContainer = () => import ('@/containers/EmptyNonContainer')

const NotFound     = () => import('@/views/NotFound')
const AccessDenied = () => import('@/views/AccessDenied')

export default [
    {
        path: '/',
        redirect: 'dashboard',
        component: TheContainer,
        meta: {
            requiresAuth: true,
        },
        children: [
            dashboard,
            // pageBuilder,
            promotions,
            publishers,
            conversions,
            transactions,
            // commissions,
            coupons,
            media,
            products,
            developers,
            // tutorials,
            links,
            stores,
            users,
            reports,
            account,
            notifications,
            tickets,
            // roles,
            v2commissions,
            shortLinks,
            agreements,
            contactUs,
            campaigns,
            tags,
            conversations,
        ],
    },


    {
        path: '/',
        redirect: 'setup',
        component: EmptyNonContainer,
        meta: {
            requiresAuth: true,
        },
        children: [
            setup,
        ]
    },

    oauth2,

    {
        path: '/access-denied',
        name: 'access_denied',
        component: AccessDenied
    },

    {
        path: '*',
        name: 'not_found',
        component: NotFound
    }
]